import { buildSeasonTagWithWildcards } from '../../utils/seasonUtils';
import { LegacyCropsMap } from '../types/LegacyCropsMap';

import { HarvestEvents } from '../../types/Harvest';
import { HarvestYield } from '../../types/HarvestYield';
import { UapiGetHarvestEventAggregatesArdQuery } from '../../graphql/sdk';

type HarvestEventByCropSeason = NonNullable<
  NonNullable<
    NonNullable<UapiGetHarvestEventAggregatesArdQuery['field']>['harvestEventAggregates']
  >['eventsByCropSeason']
>[number];

interface AdaptHarvestEventParams {
  fieldUuid: string;
  seasonTag: string;
  harvestEvent: HarvestEventByCropSeason;
}

function adaptHarvestEvent({
  fieldUuid,
  seasonTag,
  harvestEvent: {
    harvestedArea,
    nominalWeight,
    averageStdYield,
    wetMass,
    dryMass,
    moistureMass,
    moisturePercent,
    crop,
    legacySeasonTag,
  }
}: AdaptHarvestEventParams): HarvestYield {
  return {
    fieldUuid,
    seasonTag,
    nominalWeight: nominalWeight?.v || null,
    yieldAverage: averageStdYield.u ? {
      q: averageStdYield.v,
      u: averageStdYield.u,
    } : null,
    totalYield: dryMass.u ? {
      q: dryMass.v,
      u: dryMass.u,
    } : null,
    standardisedAverageYield: null,
    mass: {
      wet: wetMass && wetMass.u ? {
        q: wetMass.v,
        u: wetMass.u,
      } : null,
      dry: dryMass && dryMass.u ? {
        q: dryMass.v,
        u: dryMass.u,
      } : null,
      moisture: moistureMass && moistureMass.u ? {
        q: moistureMass.v,
        u: moistureMass.u,
      } : null,
      avgMoisture: moisturePercent && moisturePercent.u ? {
        q: moisturePercent.v,
        u: moisturePercent.u,
      } : null
    },
    area: {
     harvest: harvestedArea.u ? {
        q: harvestedArea.v,
        u: harvestedArea.u,
     } : null
    },
    crop,
    legacySeasonTag: legacySeasonTag || '',
  }
}

export function adaptUapiHarvestResponse(
  response: UapiGetHarvestEventAggregatesArdQuery,
  cropsMaps: LegacyCropsMap
): HarvestEvents {
  const defaultResult: HarvestEvents = {
    events: {},
    harvestSeasons: [],
  };

  const eventsByCropSeason = response?.field?.harvestEventAggregates?.eventsByCropSeason || [];

  if(!response.field?.id) {
    return defaultResult;
  }

  const fieldUuid = response.field.id;

  return eventsByCropSeason.reduce((accum, currentHarvestEvent) => {
    const { seasonYear, seasonName, crop } = currentHarvestEvent;

    const seasonTag = buildSeasonTagWithWildcards({
      year: seasonYear,
      season: seasonName,
      cropCode: cropsMaps[crop.id]
    });

    if (!accum.events[seasonTag]) {
      return {
        ...accum,
        events: {
          ...accum.events,
          [seasonTag]: adaptHarvestEvent({
            fieldUuid,
            seasonTag,
            harvestEvent: currentHarvestEvent,
          }),
        },
        harvestSeasons: [
          ...accum.harvestSeasons,
          seasonTag
        ]
      };
    }

    return accum;
  }, defaultResult);
}